<form
    #form
    fsForm
    [submit]="save"
    *fsSkeletonForm="environmentCreate">
  <mat-card-content>
    <div class="fs-column">
      <h2>
        Please enter the name of your organization
      </h2>
      <mat-form-field class="full-width">
        <mat-label>
          Organization Name
        </mat-label>
        <input
          matInput
          [(ngModel)]="environmentCreate.name"
          fsFormRequired
          name="name"
          autoFocus1>
        <mat-hint>
          This can be changed later
        </mat-hint>
      </mat-form-field>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button
        type="submit"
        mat-flat-button
        color="primary"
        class="full-width">
      Continue
    </button>
  </mat-card-actions>
</form>